import React from "react";
import Maincontent from "./Pages/Maincontent";

const ProvideNumber = () => {
  return (
    <>
      <div className="provideNumber">
        <Maincontent />
      </div>
    </>
  );
};

export default ProvideNumber;
